import last from 'lodash/last'
import { dynamicDescription, money } from '@sellpy/commons'
import { locale } from '../../common/region/config'
import { getRegion } from '../region/region'

const _getCategoryNameFromIndex = (index) => `item_category${index !== 0 ? index + 1 : ''}`

export const analyticsItemMapper = (item) => {
  if (!item) {
    return null
  }
  const price =
    item.price ?? (item[`price_${getRegion()}`] && money.toBaseUnit(item[`price_${getRegion()}`]))
  const discount = item.itemDiscount && money.toBaseUnit(item.itemDiscount)
  const data = {
    item_id: item.objectID,
    item_name: dynamicDescription.itemFullTitle({
      metadata: item.metadata,
      locale
    }),
    item_brand: item.metadata?.brand,
    price: price?.amount,
    discount: discount?.amount,
    currency: price?.currency,
    affiliation: item.user,
    item_variant: item.metadata?.size,
    location_id: item.storageSite,
    region: getRegion(),

    // This snippet breaks last entry from the item.categories array into an array of values,
    // and then maps them to properties on the return object. Example:
    // This:
    // categories: {
    //   category1: ['Category1 > SubCategory1 > SubSubCategory1']
    // }
    // Becomes:
    // item_category: 'Category1',
    // item_category2: 'SubCategory1',
    // item_category3: 'SubSubCategory1',
    ...(item.categories &&
      Object.fromEntries(
        last(last(Object.entries(item.categories))[1])
          .split(' > ')
          .map((category, index) => [_getCategoryNameFromIndex(index), category])
      )),
    item_category5: item.metadata?.type,
    quantity: item.quantity || 1,
    index: 0
  }
  return Object.fromEntries(Object.entries(data).filter(([_, value]) => value))
}
